import { AppNS } from 'app';
import { object, string } from 'yup';

export interface FormValues {
  ticketType: AppNS.TicketType | '';
  subjectType: AppNS.SubjectType | '';
  parentTicketId: string;
  inspectorProfileId: string;
  inspectorId: string;
  companyId: string;
  disciplineForDeactivationId: string;
  documentIds: string[];
  deactivationScope: AppNS.DeactivationScope | '';
  description: string;
  reviewerId: string;
  subject: string | null;
  deadline: string | null;
  deactivationTiming: AppNS.DeactivationTiming;
}

export const defaultValues: FormValues = {
  ticketType: '',
  subjectType: '',
  parentTicketId: '',
  inspectorProfileId: '',
  inspectorId: '',
  companyId: '',
  disciplineForDeactivationId: '',
  documentIds: [],
  deactivationScope: '',
  description: '',
  reviewerId: '',
  subject: null,
  deadline: null,
  deactivationTiming: 'after_deadline',
};

const detailsFields = {
  subjectType: string().trim().required('Field is required'),
  ticketType: string().trim().required('Field is required'),
  description: string().trim().required('Field is required'),
  reviewerId: string().trim().required('Field is required'),
  deactivationScope: string().required('Scope is required'),

  disciplineForDeactivationId: string()
    .trim()
    .when(['deactivationScope'], {
      is: (deactivationScope: string) => {
        return deactivationScope === 'discipline';
      },
      then: () => string().trim().required('Discipline is required when discipline scope is selected.'),
    }),
  subject: string().default('').trim().nullable().required('Field is required'),
  deadline: string().default('').trim().nullable().required('Field is required'),
  deactivationTiming: string().default('after_deadline').trim().required('Field is required'),
};

export const getValidationSchema = () => {
  return object({
    ...detailsFields,
  });
};
